import { render, staticRenderFns } from "./DateRender.vue?vue&type=template&id=681f658a&scoped=true&"
import script from "./DateRender.vue?vue&type=script&lang=ts&"
export * from "./DateRender.vue?vue&type=script&lang=ts&"
import style0 from "./DateRender.vue?vue&type=style&index=0&id=681f658a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f658a",
  null
  
)

export default component.exports